export const downloadFile = (url, contentType, fileName, onErrorResponse) => {
  fetch(url, {
    method: 'GET',
    headers: {
      'Content-Type': contentType,
    },
    credentials: 'include',
  })
    .then((response) => response.blob())
    .then((blob) => {
      if(onErrorResponse !== undefined && blob.type === 'application/problem+json') {
        blob.text().then((text) => {
          const json = JSON.parse(text);
          onErrorResponse(json);
        });
      } else {
        const fileUrl = window.URL.createObjectURL(new Blob([blob]));

        const link = document.createElement('a');
        link.href = fileUrl;
        link.download = fileName;

        console.log({ link, url, fileUrl });

        document.body.appendChild(link);

        link.click();

        link.parentNode.removeChild(link);
      }
    });
};
